/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-1",
    "aws_appsync_graphqlEndpoint": "https://oyvw5tt44nhbtpav7e5gxdfk4a.appsync-api.ap-southeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-southeast-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-kdp6fsgtvfdjnjecdmp4w4mubm",
    "aws_cognito_identity_pool_id": "ap-southeast-1:f51b3c60-f060-4fcd-8432-9839af536fcc",
    "aws_cognito_region": "ap-southeast-1",
    "aws_user_pools_id": "ap-southeast-1_oUp9NNnJy",
    "aws_user_pools_web_client_id": "4644682squjh6ql9o3mcrgv0fs",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "reactproject7d9085ac6bfe647f19d55b12c01dc220c131438-backend",
    "aws_user_files_s3_bucket_region": "ap-southeast-1"
};


export default awsmobile;
